// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseIconSlotWrapper_icon_2GcLV"};